import React from "react";
import { BRAND, LOGO_URL, LOGO_URL_WHITE } from "../data/content";

// Componente de logotipo con área de seguridad.
// Cuando se carguen LOGO_URL / LOGO_URL_WHITE en data/content.js,
// el logotipo oficial reemplazará automáticamente el texto temporal.
export const Logo = ({ light = false, className = "", heightClass = "h-11 sm:h-12" }) => {
  const src = light ? LOGO_URL_WHITE : LOGO_URL;

  if (src) {
    return (
      <img
        src={src}
        alt={BRAND.name}
        data-testid="brand-logo"
        className={`${heightClass} w-auto object-contain ${className}`}
      />
    );
  }

  // Placeholder tipográfico temporal
  return (
    <div
      data-testid="brand-logo-fallback"
      className={`flex flex-col items-start leading-none ${className}`}
    >
      <span
        className={`text-lg font-bold tracking-tight ${
          light ? "text-white" : "text-[#7D5A44]"
        }`}
      >
        COLLECTIVE CO LIVING
      </span>
      <span
        className={`text-[10px] font-light tracking-[0.18em] uppercase ${
          light ? "text-white/70" : "text-[#B2967D]"
        }`}
      >
        Comunidad en CDMX
      </span>
    </div>
  );
};
